import { useLayoutStyles } from '@/components/blocks/hooks'
import { BlockRenderer } from '../../BlockRenderer'
import type { BlockVisualProps } from '../../Types'
import type { ColumnBlock } from '@/types/blocks/layout/Column'
import type { PlayBlock_Union } from '@/types/blocks'
import './column-visual.css'

// Extended type for blocks with resolved children (runtime property added by BlockResolutionService)
type ColumnBlockWithChildren = ColumnBlock & { __resolved_children?: PlayBlock_Union[] }

export function ColumnVisual({ block }: BlockVisualProps) {
	// Call hooks unconditionally (React rules of hooks)
	const columnBlock = block as ColumnBlockWithChildren
	const layoutStyles = useLayoutStyles(columnBlock.properties?.layout, 'column')

	// Type guard - return early AFTER hooks
	if (block.type !== 'column') return null

	return (
		<div className="column-visual" style={layoutStyles} data-block-id={columnBlock.id}>
			{columnBlock.__resolved_children?.map((child) => <BlockRenderer key={child.id} block={child} />)}
		</div>
	)
}
